export const PANEL_ID_MAIN = 'V1_PANEL_MAIN';
export const PANEL_ID_LEGAL_NOTICE = 'V1_PANEL_LEGAL_NOTICE';
export const PANEL_ID_COOKIE_CONSENT = 'V1_PANEL_COOKIE_CONSENT';
export const PANEL_ID_TECHNICALLY_NECESSARY = 'V1_PANEL_TECHNICALLY_NECESSARY';
